

















import Pagination from '@/components/ui/Pagination.vue'
import { printError } from '@/lib/utils';
import { TelegramUser } from '@/lib/types'
import api from '@/lib/api'
import Vue from 'vue'
export default Vue.extend({
    data(){
        return {
            users: {} as { [key: string]: TelegramUser },
            pages: 1,
            page: 1,
            current_user: {} as TelegramUser
        }
    },
    components: { Pagination },
    async beforeMount(){

        const params = new URLSearchParams(location.search);
        const val = params.entries().next().value;
        if(val) this.page = parseInt(val[1]);
        else this.page = 1;    
        
        try{

            const res = await api.telegram.users.paginate(this.page);
            this.users = res.users;    
            this.pages = res.pages;

        }catch(err){
        
            printError(err as any);

        }

    }

})
